import { render, staticRenderFns } from "./editLabel.vue?vue&type=template&id=7df6c3d4&scoped=true&"
import script from "./editLabel.vue?vue&type=script&lang=js&"
export * from "./editLabel.vue?vue&type=script&lang=js&"
import style0 from "./editLabel.vue?vue&type=style&index=0&id=7df6c3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6c3d4",
  null
  
)

component.options.__file = "editLabel.vue"
export default component.exports